import {Component, OnDestroy, OnInit} from '@angular/core';
import {NotificationService} from "../../../core/service/notification.service";
import {ActiveNotification} from "../../../core/responses/notifications/ActiveNotification";
import {takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";
import {NotificationView} from "../../../core/responses/notifications/NotificationView";
import {NotificationAlertType} from "../../../core/helpers/constants";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-notification-banner',
  templateUrl: './notification-banner.component.html',
  styleUrls: ['./notification-banner.component.scss']
})
export class NotificationBannerComponent implements OnInit, OnDestroy {

  private ngUnsubscribe = new Subject<void>();
  public showBanner = false;
  public notification: NotificationView;
  public currentLang: string;
  constructor(
    private notificationService: NotificationService,
    private translateService: TranslateService
  ) {
    this.currentLang = translateService.currentLang;
    this.translateService.onLangChange.subscribe(() => {
      this.currentLang = translateService.currentLang;
    });
  }
  ngOnInit(): void {
    this.notificationService.getActiveNotifications()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (value: Array<ActiveNotification>) => {
        if (value && value.length > 0) {
          this.showBanner = true;
          this.notification = {
            contentEn: value[0].contentEn,
            contentRo: value[0].contentRo,
            dismissable: value[0].dismissable,
            notificationType: NotificationAlertType[value[0].notificationType]
          };
        }
      }
    })
  }
  public ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
